import React from 'react';
import PropTypes from 'prop-types';

const Chart = ({ id, copyright }) =>
  id ? (
    <div className={`chart chart_${id}`}>
      <div>
        <div className="canvas-wrapper" />
        <div className="legend-wrapper">
          <svg className={`legend legend_${id}`} />
        </div>
      </div>
      <p className={`copyright${copyright ? '' : ' hide'}`}>
        ©&nbsp;Bayerisches Klimainformationssystem LfU&nbsp;
        {new Date().getFullYear()}
      </p>
    </div>
  ) : (
    <></>
  );

Chart.propTypes = {
  id: PropTypes.string,
  copyright: PropTypes.bool,
};

Chart.defaultProps = {
  id: null,
  copyright: null,
};

export default Chart;
